// Layout/NotificationPanel.jsx
import React from "react";

export default function NotificationPanel({ notifications, markAllAsRead }) {
  return (
    <div className="absolute right-0 mt-2 w-72 bg-gray-900 rounded-lg shadow-xl border border-gray-800 z-50">
      <div className="p-3 border-b border-gray-800 flex justify-between items-center">
        <h3 className="font-medium">Notificaciones</h3>
        <button
          onClick={markAllAsRead}
          className="text-xs text-blue-400 hover:text-blue-300"
        >
          Marcar todo como leído
        </button>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {notifications.length > 0 ? (
          notifications.map((notification) => (
            <div
              key={notification.id}
              className={`p-3 border-b border-gray-800 hover:bg-gray-800 ${
                !notification.read ? "bg-gray-800/50" : ""
              }`}
            >
              <div className="flex justify-between items-start">
                <p
                  className={`text-sm ${
                    !notification.read ? "font-medium" : ""
                  }`}
                >
                  {notification.text}
                </p>
                {!notification.read && (
                  <div className="h-2 w-2 bg-blue-500 rounded-full"></div>
                )}
              </div>
              <p className="text-xs text-gray-400 mt-1">{notification.time}</p>
            </div>
          ))
        ) : (
          <div className="p-4 text-center text-gray-400">
            No hay notificaciones
          </div>
        )}
      </div>
      <div className="p-2 text-center border-t border-gray-800">
        <button className="text-sm text-blue-400 hover:text-blue-300">
          Ver todas
        </button>
      </div>
    </div>
  );
}
